var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"border-1 border-gray border-bottom",class:[_setup.props.my]})
}
var staticRenderFns = []

export { render, staticRenderFns }